import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.trim.js";
var flag = 0;
var img;
var img1;
var img3;
var commentParams = {
  'filter[thread]': '',
  sort: 'createdAt',
  page: 1,
  perPage: 20,
  index: 1
};
var params = {
  isComment: 1,
  id: '',
  content: '',
  replyId: '',
  commentPostId: ''
};
import { detail, comments, follow, unFollow, postComments, thumbs, collect, signUp, threadDelete } from '@/api/mg';
import getPx from '@/utils/getPx';
import QRCode from 'qrcodejs2';
import $ from 'jquery';
export default {
  watch: {
    show: function show() {
      this.item.isSelected = this.show;
    }
  },
  data: function data() {
    return {
      show: false,
      placeholder: 'Say something',
      commentList: [],
      detailData: {
        content: {
          text: ''
        }
      },
      isEmpty: true,
      isFocus: false,
      isFollow: true,
      inputValue: '',
      threadId: '',
      userId: '',
      storeUserId: '',
      qrcode: '',
      item: '',
      canvasImgSrc: '',
      shiftArr: []
    };
  },
  created: function created() {
    flag = 0;
    this.storeUserId = localStorage.getItem('userId');
    this.title = this.$route.query.from;
    this.threadId = this.$route.query.threadId;
    console.log(this.title, this.threadId);
    var params = {
      threadId: this.threadId,
      type: 'share'
    };
    this.getDetail(params);
    commentParams['filter[thread]'] = this.threadId;
    commentParams['type'] = 'share';
    this.getComments(commentParams);
  },
  mounted: function mounted() {},
  methods: {
    // toJump() {
    //   this.openApp('mgismartIndia://', this.toUrl)
    // },
    // toUrl() {
    //   var u = navigator.userAgent
    //   var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
    //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端
    //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    //   if (isAndroid) {
    //     window.location.href = 'https://play.google.com/store/apps/details?id=com.saicmotor.iov.europe'
    //   }
    //   if (isIOS) {
    //     window.location.href = 'https://apps.apple.com/cn/app/mg-ismart-europe/id1567002359'
    //   }
    // },
    // openApp(url, callback) {
    //   var u = navigator.userAgent
    //   var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
    //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端
    //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    //   if (isAndroid || isIOS) {
    //     var timeout; var t = 4000; var hasApp = true
    //     var openScript = setTimeout(function() {
    //       if (!hasApp) {
    //         callback && callback()
    //       }
    //       document.body.removeChild(ifr)
    //     }, 5000)
    //     var t1 = Date.now()
    //     var ifr = document.createElement('iframe')
    //     console.log(ifr, 'ifr')
    //     ifr.setAttribute('src', url)
    //     // ifr.setAttribute('style', 'display:none')
    //     document.querySelector('.container').appendChild(ifr)
    //     timeout = setTimeout(function() {
    //       var t2 = Date.now()
    //       if (t2 - t1 < t + 100) {
    //         hasApp = false
    //       }
    //     }, t)
    //   }
    // },
    toJump: function toJump() {
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

      // 微信内
      if (isWeixin) {
        alert('请在浏览器上打开');
      } else {
        // android端
        if (isAndroid) {
          // 安卓app的scheme协议
          window.location.href = 'mgismartIndia://';
          var timer = setTimeout(function () {
            var hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden;
            if (typeof hidden === 'undefined' || hidden === false) {
              // 安卓应用市场下载地址
              window.location.href = 'https://play.google.com/store/apps/details?id=com.saicmotor.ismartthai';
              clearTimeout(timer);
            }
          }, 2000);
        }
        // ios端
        if (isIOS) {
          // ios的scheme协议
          window.location.href = 'mgismartIndia://';
          var _timer = setTimeout(function () {
            var hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden;
            if (typeof hidden === 'undefined' || hidden === false) {
              // App store下载地址
              window.location.href = 'https://apps.apple.com/cn/app/mg-thailand/id1614430167';
              clearTimeout(_timer);
            }
          }, 2000);
        }
      }
    },
    toDelete: function toDelete(threadId) {
      var _this = this;
      threadDelete({
        threadId: threadId
      }).then(function (res) {
        if (res.Code === 0) {
          _this.$router.back();
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toMe: function toMe(pid) {
      // this.$router.push({ path: '/me', query: { pid }})
    },
    toSign: function toSign(type) {
      var _this2 = this;
      signUp({
        threadId: this.threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          _this2.$toast(res.Message);
          var _params = {
            threadId: _this2.threadId
          };
          _this2.getDetail(_params);
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId
        }
      });
    },
    toCollect: function toCollect(isFavorite, threadId) {
      var _this3 = this;
      var params = {
        id: threadId,
        isFavorite: !isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          var _params2 = {
            threadId: _this3.threadId
          };
          _this3.getDetail(_params2);
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    imgLoad: function imgLoad() {
      // MG图片
      img1 = new Image();
      img1.src = require('../../assets/images/MG_1.png');
      img1.onload = function () {
        flag++;
        console.log('MG图片加载完成', img1);
      };
      // 头像
      img = new Image();
      if (this.detailData.user.avatar) {
        img.src = this.detailData.user.avatar;
        console.log(this.detailData.user.avatar, 'this.detailData.user.avatar');
      }
      img.onload = function () {
        flag++;
        console.log('头像加载完成', img);
      };
      // 背景图片
      img3 = new Image();
      img3.src = require('../../assets/images/P8.png');
      img3.onload = function () {
        flag++;
        console.log('背景图片加载完成', img3);
      };
    },
    fullscreen: function fullscreen(elem) {
      var prefix = 'webkit';
      if (elem[prefix + 'EnterFullScreen']) {
        return prefix + 'EnterFullScreen';
      } else if (elem[prefix + 'RequestFullScreen']) {
        return prefix + 'RequestFullScreen';
      }
      return false;
    },
    autoFullScrenn: function autoFullScrenn(v) {
      var ua = navigator.userAgent.toLowerCase();
      var Android = String(ua.match(/android/i)) === 'android';
      if (!Android) return; // 非android系统不使用;
      var video = v;
      var doc = document;
      var fullscreenvideo = this.fullscreen(doc.createElement('video'));
      if (!this.fullscreen) {
        this.$toast('不支持全屏模式');
        return;
      }
      video.addEventListener('webkitfullscreenchange', function (e) {
        if (!doc.webkitIsFullScreen) {
          // 退出全屏暂停视频
          this.pause();
          // this.pause();
        }
      }, false);
      video.addEventListener('click', function () {
        this.play();
        video[fullscreenvideo]();
      }, false);
      video.addEventListener('ended', function () {
        doc.webkitCancelFullScreen(); // 播放完毕自动退出全屏
      }, false);
    },
    creatQrCode: function creatQrCode() {
      var _this4 = this;
      new QRCode(this.$refs.qrCodeUrl, {
        text: location.href.replace('detail', 'share'),
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      this.$nextTick(function () {
        _this4.qrcode = document.querySelector('.qrcode canvas');
        console.log(_this4.qrcode, 'this.qrcode');
      });
    },
    toComment: function toComment(pid) {
      this.$router.push({
        path: '/social/comment',
        query: {
          pid: pid,
          threadId: this.threadId
        }
      });
    },
    del: function del() {
      var params = {
        pid: this.pid,
        data: {
          attributes: {
            isDeleted: true
          }
        }
      };
      this.thumpsApi(params, 'delete');
    },
    cancel: function cancel() {
      this.item.isSelected = false;
      this.show = false;
    },
    start: function start(userId, pid, item) {
      this.blur();
      this.userId = userId;
      this.pid = pid;
      this.item = item;
    },
    longpress: function longpress() {
      console.log('进入langPress', localStorage.getItem('userId'), this.userId, this.item);
      if (localStorage.getItem('userId') === this.userId + '') {
        this.item.isSelected = true;
        this.show = true;
      }
    },
    thumbsUp: function thumbsUp(pid, isLike, threadId) {
      if (threadId) {
        var _params3 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid,
          id: threadId
        };
        this.thumpsApi(_params3, 'thread');
      } else {
        var _params4 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid
        };
        this.thumpsApi(_params4, 'comment');
      }
    },
    thumpsApi: function thumpsApi(params, type) {
      var _this5 = this;
      if (JSON.parse(localStorage.getItem('appParams')).token) {
        params.token = JSON.parse(localStorage.getItem('appParams')).token;
      }
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'delete') {
            _this5.item.isSelected = false;
            _this5.show = false;
            _this5.getComments(commentParams);
          }
          if (type === 'comment') {
            _this5.getComments(commentParams);
          }
          if (type === 'thread') {
            var _params5 = {
              threadId: _this5.threadId
            };
            _this5.getDetail(_params5);
          }
        } else {
          _this5.$toast(res.Message);
        }
      });
    },
    toReply: function toReply(name, replyId, commentPostId) {
      this.$refs.inputs.focus();
      params.replyId = replyId;
      if (commentPostId) {
        params.commentPostId = commentPostId;
      } else {
        params.commentPostId = '';
      }
      console.log(params, 'params');
      this.placeholder = 'reply ' + name + ':';
    },
    post: function post(params) {
      var _this6 = this;
      if (JSON.parse(localStorage.getItem('appParams')).token) {
        params.token = JSON.parse(localStorage.getItem('appParams')).token;
      }
      params.type = 'share';
      postComments(params).then(function (res) {
        if (res.Code === 0) {
          _this6.item = '';
          params.replyId = '';
          _this6.placeholder = 'Say something';
          _this6.getComments(commentParams);
        } else {
          _this6.$toast(res.Message);
          var _params6 = {
            threadId: _this6.threadId
          };
          _this6.getDetail(_params6);
        }
      });
    },
    getComments: function getComments(params) {
      var _this7 = this;
      // if (JSON.parse(localStorage.getItem('appParams')).token) {
      //   params.token = JSON.parse(localStorage.getItem('appParams')).token
      // }
      comments(params).then(function (res) {
        if (res.Code === 0) {
          _this7.commentList = res.Data.pageData;
        } else {
          _this7.$toast(res.Message);
        }
      });
    },
    getDetail: function getDetail(params) {
      var _this8 = this;
      detail(params).then(function (res) {
        if (res.Code === 0) {
          _this8.detailData = res.Data;
          if (_this8.detailData['content']['indexes']['101']['body'].length > 0) {
            var data = JSON.parse(JSON.stringify(_this8.detailData['content']['indexes']['101']['body']));
            if (data[0].type === 1 || data[0].type === 0) {
              data.shift();
            }
            _this8.shiftArr = data;
            console.log(_this8.detailData['content']['indexes']['101']['body']);
          }
          console.log(_this8.detailData, 'this.detailData');
        } else {
          _this8.$toast(res.Message);
        }
      });
    },
    send: function send() {
      if (this.inputValue.trim()) {
        if (params.replyId) {
          params.content = this.inputValue;
          params.id = this.threadId;
          this.post(params);
        } else {
          var params1 = {
            id: this.threadId,
            content: this.inputValue.trim()
          };
          this.post(params1);
        }
        this.isFocus = false;
        this.inputValue = '';
        this.isEmpty = true;
      }
    },
    input: function input(val) {
      if (val.trim()) {
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
    },
    isIos: function isIos() {
      var m = navigator.userAgent;
      var isIos = !!m.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var result = !!isIos;
      return result;
    },
    handleResize: function handleResize() {
      this.$toast('键盘弹起');
      var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (resizeHeight < this.originHeight) {
        // 当软键盘弹起，在此处操作
        if (!this.isIos()) {
          this.isFocus = true;
          this.$toast('键盘弹起');
        }
      } else {
        // 当软键盘收起，在此处操作
        if (!this.isIos()) {
          this.isFocus = false;
          this.$toast('键盘收起');
        }
      }
    },
    blur: function blur() {
      if (!this.inputValue) {
        this.isFocus = false;
        this.$refs.inputs.blur();
        this.item = '';
        params.replyId = '';
        this.placeholder = 'Say something';
      }
      // this.isFocus = false
      // this.inputValue = ''
      // this.isEmpty = true
    },
    focus: function focus() {
      this.isFocus = true;
      this.$refs.inputs.focus();
    },
    share: function share() {
      // this.$toast('开发中...')
      // return
      console.log(flag, 'flag');
      if (flag === 3 && this.qrcode) {
        this.draw();
      } else {
        this.$toast('picture loading incomplete');
      }
    },
    getShareModule: function getShareModule(imgSrc) {
      console.log(imgSrc, 'imgSrc');
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.Android.share(imgSrc);
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        this.$bridge.callhandler('share', {
          'content': imgSrc
        }, function (response) {});
      }
    },
    draw: function draw() {
      var c = document.getElementById('canvas');
      c.setAttribute('width', getPx(660) + 'px');
      c.setAttribute('height', getPx(900) + 'px');
      c.setAttribute('style', 'display:block;');
      this.$toast('图片已生成');
      var timer = setTimeout(function () {
        c.setAttribute('style', 'display:none;');
        clearTimeout(timer);
      }, 3000);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#2c2e31';
      ctx.fillRect(0, 0, getPx(660), getPx(900));
      // img.setAttribute('crossOrigin', 'anonymous')
      // img1.setAttribute('crossOrigin', 'anonymous')
      // img3.setAttribute('crossOrigin', 'anonymous')
      // this.qrcode.setAttribute('crossOrigin', 'anonymous')
      ctx.drawImage(img3, getPx(0), getPx(0), getPx(660), getPx(634));
      ctx.drawImage(img, getPx(25), getPx(468), getPx(70), getPx(70));
      ctx.drawImage(img1, getPx(578), getPx(794), getPx(50), getPx(50));
      ctx.drawImage(this.qrcode, getPx(25), getPx(724), getPx(120), getPx(120));
      // c.width = img.width
      // c.height = img.height
      // // 获取图片宽高的最小值
      // const min = Math.min(img.width, img.height)
      // const r = min / 2

      // ctx.fillStyle = ctx.createPattern(img, 'no-repeat')
      // ctx.arc(img.width / 2, img.height / 2, r, 0, Math.PI * 2)
      // ctx.fill()
      // ctx.clearRect(getPx(25), getPx(468), getPx(70), getPx(70))
      // ctx.fillStyle = ctx.createPattern(img, 'no-repeat')
      // ctx.arc(getPx(25) + getPx(70 / 2), getPx(468), getPx(70 / 2), 0, Math.PI * 2)
      // ctx.fill()
      ctx.font = "".concat(getPx(28), "px medium");
      ctx.fillStyle = ' #fff';
      ctx.fillText(this.detailData.user.nickname, getPx(112), getPx(487 + 28), getPx(522));
      ctx.font = "".concat(getPx(22), "px medium");
      ctx.fillStyle = 'rgba(255,255,255,0.50)';
      ctx.fillText('Scan QR Code', getPx(165), getPx(784 + 22), getPx(522));
      ctx.font = "".concat(getPx(22), "px medium");
      ctx.fillStyle = 'rgba(255,255,255,0.50)';
      ctx.fillText('Check The Details', getPx(165), getPx(814 + 22), getPx(522));
      // // 绘制多行文字
      // this.canvasTextAutoLine(str, c, 375 * 0.1, 640 * 0.5, 20)
      this.canvasImgSrc = c.toDataURL('image/png');
      this.getShareModule(this.canvasImgSrc);
    },
    canvasTextAutoLine: function canvasTextAutoLine(str, canvas, initX, initY, lineHeight) {
      var ctx = canvas.getContext('2d');
      var lineWidth = 0;
      var canvasWidth = document.documentElement.clientWidth;
      var lastSubStrIndex = 0;
      for (var i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width;
        if (lineWidth > canvasWidth * 0.8) {
          // 减去initX,防止边界出现的问题
          ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
          initY += lineHeight;
          lineWidth = 0;
          lastSubStrIndex = i;
        }
        if (i === str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
        }
      }
    },
    toFollow: function toFollow(userId) {
      var _this9 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this9.threadId
          };
          _this9.getDetail(params1);
        } else {
          _this9.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId) {
      var _this10 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this10.threadId
          };
          _this10.getDetail(params1);
        } else {
          _this10.$toast(res.Message);
        }
      });
    },
    back: function back() {
      var _this11 = this;
      var timer = setTimeout(function () {
        _this11.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    getKeyCode: function getKeyCode(e) {
      // this.$toast(e.keyCode)
      if (e.keyCode === 13) {
        // this.$toast('发送')
      }
    }
  }
};